import i18n, { type InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DataKeys } from '../constants/login';
import en_EN from '../translations/en.json';
import nl_NL from '../translations/nl.json';

export type TTranslationKeys = keyof typeof en_EN;

export const resources = {
  en: {
    translation: en_EN,
  },
  nl: {
    translation: nl_NL,
  },
} as const;

const initOptions: InitOptions = {
  resources,
  lng: localStorage.getItem(DataKeys.SELECTED_LANGUAGE) || 'en',
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
};

export const initI18N = () => {
  i18n.use(initReactI18next).init(initOptions);
};

export const switchLanguage = (language: string) => {
  i18n.changeLanguage(language);
  localStorage.setItem(DataKeys.SELECTED_LANGUAGE, language);
};

export const getSelectedLanguage = () => {
  return i18n.language;
};

export default i18n;
